import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import {globalfunc} from '../globalfunc.js'
export default {
    namespaced: true,
    state: {
        membersall: [],
        membersByTeam: [],
        membersByCohort: [],
        membersByHouse: [],
        cohorts:[],
        cohortsall:[],
        inputSearch: '',
        page:1,
        size_page:10,
        results: 0,
        sortBy: 'name',
        cohortsDuplicate: [],
        organizations: [],
        loadingCohortsTable: true,
        house:{
            1:'-LWPrZbcyHAVHIFUsWLd', //Corvus
            2:'-LWOr-XsbZM2digYl1QL', //Delphinus
            3:'-LWPrOElCYViBd6j6qP-', //Leonos
        },
        cohortRandomNumber: '',
    },
    mutations: {
        setCohorts(state:any, result:any) {
            state.cohorts = result
        },
        setCohortsAll(state:any, result:any) {
            state.cohortsall = result
        },
        setinputSearch(state:any,value:any) {
            state.inputSearch = value.value
        },
        setPage(state:any,result:any) {
            state.page = result
        },
        setResults(state:any, result:any) {
            state.results = result
        },
        setCohortsDuplicate(state:any, result:any) {
            state.cohortsDuplicate = result
        },
        setLoadingCohortsTable(state:any, result:any) {
            state.loadingCohortsTable = result
        },
        setMembersByTeam(state:any, result:any) {
            state.membersByTeam = result
        },
        setMemberall(state:any, result:any) {
            state.membersall = result
        },
        setMemberByCohort(state:any, result:any) {
            state.membersByCohort = result
        },
        setMemberByHouse(state:any, result:any) {
            state.membersByHouse = result
        },
        setCohortRandomNumber(state: any, value: any) {
            state.cohortRandomNumber = value
        },
    },
    actions: {
        async generateCohortRandomNumber({commit,dispatch,state,rootState}:any, cohorts:any){
            let num = 'c'+globalfunc.generateRandomNumber()
            if(!cohorts) cohorts = (await firebase.database().ref(`/cohorts`).once('value')).val();
            let duplicate = false;
            for(const comId in cohorts){
              for(const x in cohorts[comId]){
                if(cohorts[comId][x].internal_id == num){
                  duplicate = true;
                  break;
                }
              }
              if(duplicate) break;
            }
            if(duplicate){
              num = await dispatch('generateCohortRandomNumber',cohorts)
            }
            commit('setCohortRandomNumber', num)
        },
        async getCohorts({commit,dispatch,state,rootState}:any, user:any){
            commit('setLoadingCohortsTable',true)
            commit('setCohorts',[])
            commit('setPage',1)
            let dateNow = new Date()
            const checkCohorts:Array<any> = []
            let cohorts_duplicate:Array<any> = []
            cohorts_duplicate['status'] = false
            cohorts_duplicate['count'] = 0
            let userData:Array<any> = [];
            let membersByCohort:Array<any> = [];
            let membersByTeam:Array<any> = [];
            let membersByHouse:Array<any> = [];
            let noDup = 0
            const company = (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
            const team = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
            for(const arrData in rootState.main.allUser){
                const u =rootState.main.allUser[arrData]
                u.key = arrData
                if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
                if(u.profilepic_small){
                    u.pic = u.profilepic_small;
                  }else if (u.profilepic_crop){
                    u.pic = u.profilepic_crop;
                  }else if (u.profilepic){
                    u.pic = u.profilepic;
                  }else {
                    u.pic = "";
                  }
                if(u.tutorial && u.tutorial == 'Y'){
                let dayActive = differenceInCalendarDays(dateNow, u.updated)
                if(dayActive > 30){
                    u.status = 'inactive'
                    u.to_now = format(u.updated,'MMM D, YYYY')
                }else{
                    u.status = 'active'
                    u.to_now = globalfunc.timeSince(u.updated)
                }
                }else if(u.invited){
                    u.status = 'invited'
                    u.to_now = globalfunc.timeSince(u.updated)
                }else{
                    u.status = 'new'
                }
                userData[u.email] = u
                if(membersByTeam[u.team] === undefined){
                    membersByTeam[u.team] = new Array()
                }
                membersByTeam[u.team].push(u)
            }


            // await firebase.database().ref().child('users').orderByChild('company').equalTo(`${user.company}`).once('value',async snapshot => {
            //     snapshot.forEach((arrData):any => {
            //         const u = arrData.val()
            //         u.key = arrData.key
            //         if(u.team) u.team_name = (team[u.team]!=undefined)?team[u.team]["name"]:''
            //         if(u.profilepic_small){
            //             u.pic = u.profilepic_small;
            //           }else if (u.profilepic_crop){
            //             u.pic = u.profilepic_crop;
            //           }else if (u.profilepic){
            //             u.pic = u.profilepic;
            //           }else {
            //             u.pic = "";
            //           }
            //         if(u.tutorial && u.tutorial == 'Y'){
            //         let dayActive = differenceInCalendarDays(dateNow, u.updated)
            //         if(dayActive > 30){
            //             u.status = 'inactive'
            //             u.to_now = format(u.updated,'MMM D, YYYY')
            //         }else{
            //             u.status = 'active'
            //             u.to_now = globalfunc.timeSince(u.updated)
            //         }
            //         }else if(u.invited){
            //             u.status = 'invited'
            //             u.to_now = globalfunc.timeSince(u.updated)
            //         }else{
            //             u.status = 'new'
            //         }
            //         userData[u.email] = u
            //         if(membersByTeam[u.team] === undefined){
            //             membersByTeam[u.team] = new Array()
            //         }
            //         membersByTeam[u.team].push(u)
            //     });
            // });
            _.forEach(state.house, (houseId, index) => {
                firebase.firestore().collection(`houses/${user.company}${houseId}/members`).orderBy('firstname').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach((doc) => {
                        const _data = doc.data()
                        _data.key = doc.id
                        if(userData[_data.email]){
                            if(membersByHouse[houseId] === undefined){
                                membersByHouse[houseId] = new Array()
                            }
                            membersByHouse[houseId].push(_data)
                        }
                    });
                });
            });
            
            firebase.database().ref(`cohorts/${user.company}`).once('value',async snapshot => {
                const cohorts:Array<any> = [];
                snapshot.forEach((doc):any => {
                    const c = doc.val()
                    c.key = doc.key
                    c.value = doc.val().name
                    c.company_name = company.name
                    if(c.sup === undefined){
                        c.sup = new Array()
                    }
                    if(c.name){
                        if(checkCohorts[c.name.toLowerCase()]){
                            cohorts_duplicate['status'] = true
                            cohorts_duplicate['count'] += 2
                            c.duplicate = true
                            c.duporder = noDup
                            noDup++
                            const cohortKey = _.findKey(cohorts, ['name', checkCohorts[c.name.toLowerCase()]])
                            if(cohortKey){
                                cohorts[cohortKey].duplicate = true
                                cohorts[cohortKey].duporder = noDup
                                noDup++
                            }
                        }
                        checkCohorts[c.name.toLowerCase()] = c.name
                    }
                    if(c.users){
                        for (const x in c.users) {
                            if(userData[c.users[x]]){
                                c.sup = _.concat(c.sup, userData[c.users[x]]);
                            }
                        }
                        c.sup = _.sortBy(c.sup, [function(o:any) { return o.firstname; }])
                    }
                    membersByCohort[c.key] = c.users
                    cohorts.push(c)
                });
                var _cohorts = _.sortBy(cohorts, [function(o:any) { return o.duporder; }, function(o:any) { return o.name; }])
                commit('setResults',_cohorts)
                commit('setCohortsDuplicate',cohorts_duplicate)
                commit('setCohorts', _cohorts.slice(0, state.size_page))
                commit('setCohortsAll', _cohorts)
                commit('setLoadingCohortsTable',false)
                commit('setMembersByTeam', membersByTeam)
                commit('setMemberall',userData)
                commit('setMemberByCohort',membersByCohort)
                commit('setMemberByHouse',membersByHouse)
                if(state.inputSearch){
                    dispatch('searchCohorts',state.inputSearch)
                }
            }).catch(error => {
                console.log(error)
            });
        },
        async updateCohort({commit,rootState,dispatch,state}:any,form:any){
            const nowDate = format(new Date(), 'YYYY-MM-DD HH:mm')
            const member = {};
            if(form.leaderMember.length > 0){
                _.forEach(form.leaderMember, (item, index) => {
                    member[item.key] = item.email
                });
            }
            firebase.database().ref(`/cohorts/${rootState.authen.user.company}/${form.id}`).update({
                name:form.cohort_name,
                color:(form.color)?form.color:'',
                leaders: (Object.keys(member).length > 0) ? member : null,
                updated:nowDate
            }).then(()=>{
                if(Object.keys(form.newMemberAdd).length > 0){
                    firebase.database().ref(`cohorts/${rootState.authen.user.company}/${form.id}/users`).update(
                        form.newMemberAdd
                    )
                }
            }).then(()=>{
                dispatch('getCohorts',rootState.authen.user)
            });
        },
        async createCohorts({commit,rootState,dispatch,state}:any,form:any){
            const newId = firebase.database().ref(`cohorts/${rootState.authen.user.company}`).push().key;
            const nowDate = format(new Date(), 'YYYY-MM-DD HH:mm')
            const member = {};
            if(form.leaderMember.length > 0){
                _.forEach(form.leaderMember, (item, index) => {
                    member[item.key] = item.email
                });
            }
            firebase.database().ref(`cohorts/${rootState.authen.user.company}/${newId}`).update({
                name:form.cohort_name,
                color:(form.color)?form.color:'',
                created:nowDate,
                updated:nowDate,
                internal_id: form.internal_id,
                users: (Object.keys(form.newMemberAdd).length > 0) ? form.newMemberAdd : null,
                leaders: (Object.keys(member).length > 0) ? member : null,
            }).then(()=>{
                firebase.database().ref(`/calculate_cohort`).push({
                    cohort:newId,
                    company:rootState.authen.user.company
                });
                dispatch('getCohorts',rootState.authen.user)
            });
        },
        deleteCohort({commit,rootState,dispatch}:any,key:any){
            firebase.database().ref(`/cohorts/${rootState.authen.user.company}/${key}`).remove().then(()=>{
                firebase.database().ref(`/delete_cohort`).push({
                    cohort:key,
                });
                dispatch('getCohorts',rootState.authen.user) 
            });
        },
        removeUserCohort({commit,rootState,dispatch}:any,obj:any){
            firebase.database().ref(`/cohorts/${rootState.authen.user.company}/${obj.id}/users/${obj.userKey}`).remove().then(()=>{
                dispatch('getCohorts',rootState.authen.user)
            });
        },
        currentChange({commit,state}:any,page:any){
            var size = state.size_page
            var start_row = (page-1) * size
            var end_row = ((page-1) * size)+size
            let cohorts: Array<any> = [];
            
            if(state.inputSearch){
                var re = new RegExp(state.inputSearch, 'gi')
                var response = _.filter(state.cohortsall, (item):any => {
                    if (item && item.name && item.name.match(re)){
                        return true
                    } else if (item && item.description && item.description.match(re)) {
                        return true;
                    }
                });
                cohorts = response
            }else{
                cohorts = state.cohortsall
            }

            if (state.sortBy == 'name') {
                cohorts = _.sortBy(cohorts, [function(o:any) { return o.name; }])
            }
            let result = cohorts.slice(start_row,end_row)
            commit('setPage',page)
            commit('setResults', cohorts)
            commit('setCohorts', result)
        },
        searchCohorts({commit,state}:any,value:string){
            commit('setPage',1)
            let response: Array<any> = [];
            var re = new RegExp(value, 'gi')
            response = _.filter(state.cohortsall, (item):any => {
                if (item && item.name && item.name.match(re)){
                    return true
                } else if (item && item.description && item.description.match(re)) {
                    return true;
                }
            });
            if (state.sortBy == 'name') {
                response = _.sortBy(response, [function(o:any) { return o.duporder; },function(o:any) { return o.name; }])
            }
            commit('setResults', response)
            commit('setCohorts',response.slice(0,state.size_page))
        },
        sortBy({ commit, state }: any, type: string) {
            commit('setPage',1)
            state.sortBy = type
            let cohorts: Array<any> = [];
            if(state.inputSearch){
                var re = new RegExp(state.inputSearch, 'gi')
                var response = _.filter(state.cohortsall, (item):any => {
                    if (item && item.name && item.name.match(re)){
                        return true
                    } else if (item && item.description && item.description.match(re)) {
                        return true;
                    }
                });
                cohorts = response
            }else{
                cohorts = state.cohortsall
            }
            if (type == 'name') {
                cohorts = _.sortBy(cohorts, [function(o:any) { return o.duporder; },function(o:any) { return o.name; }])
            }
            commit('setCohorts',cohorts.slice(0,state.size_page))
        },
    },
    getters: {
        membersall: (state:any) => {
            return state.membersall
        },
        membersByTeam: (state:any) => {
            return state.membersByTeam
        },
        membersByCohort: (state:any) => {
            return state.membersByCohort
        },
        membersByHouse: (state:any) => {
            return state.membersByHouse
        },
        cohortsall: (state:any) => {
            return state.cohortsall
        },
        cohorts : (state:any) => {
            return state.cohorts
        },
        inputSearch: (state:any) => {
            return state.inputSearch
        },
        results : (state:any) => {
            return state.results
        },
        page : (state:any) => {
            return state.page
        },
        cohortsDuplicate : (state:any) => {
            return state.cohortsDuplicate
        },
        loadingCohortsTable : (state:any) => {
            return state.loadingCohortsTable
        },
        cohortRandomNumber : (state:any) => {
            return state.cohortRandomNumber
        },
    }
  }